var angular = require('angular');
var Promise = require('bluebird');
var AngularSetup = require('../common/utils/angular-setup');
var PortalAPI = require('./api').Portal;

require('../common/branding/index.scss');
require("../common/index.scss");
require('./index.scss');


window.$ = window.jQuery = require('jquery');
window.Tether = require('tether');
require('bootstrap');
require('angularjs-google-recaptcha-v3');

var SetupAnalytics = require('../common/analytics');

var setup = module.exports = AngularSetup('portal');

setup.state('portal', {
  abstract:true,
  template: require('./index.pug')
})

setup
.module(require('../common/deps').name)
.module(require('../common/directives').name)
.module('fayzaan.gRecaptcha.v3')

setup.state('portal.login', {
  url: '/auth?client_id&redirect_uri&state&scope',
  template: require('./login/index.pug'),
  controller: require('./login/index'),
  controllerAs: 'vm',
  resolve: {
    appDetails: function ($stateParams) {
      // if (conf.login_app && conf.login_app == $stateParams.client_id) {
      //   return Promise.resolve(conf.login_app);
      // }
      return PortalAPI.getApp($stateParams.client_id)
    }
  }
})

setup.state('portal.password',{
    url: '/forgotten-password',
    template: require('./password/index.pug')(),
    controller: require('./password/index'),
    controllerAs: 'vm'
});

setup.state('portal.reset-password',{
    url: '/resetPassword',
    template: require('./reset-password/index.pug')(),
    controller: require('./reset-password/index'),
    controllerAs: 'vm',
    data:{
      title: 'Good Exchange - Reset Password'
    }
});

setup.state('portal.signup',{
    url: '/signup',
    template: require('./signup/index.pug')(),
    controller: require('./signup/index'),
    controllerAs: 'vm',
    data: {
      title: 'Good Exchange - Signup'
    }
});

setup.state('portal.verify-email',{
    url: '/verify-email',
    template: require('./verify-email/index.pug')(),
    controller: require('./verify-email/index'),
    controllerAs: 'vm',
    data: {
      title: 'Good Exchange - Verify Email',
      isVerified: true
    },
    resolve: {
      isVerified: function(){
        return Promise.resolve(conf.email_verified);
      },
      errorMessage: function(){
        return Promise.resolve(conf.error_message);
      }
    }
});

setup.state('portal.applicant-invite',{
    url: '/applicant-invite?id',
    template: require('./invite/index.pug')(),
    controller: require('./invite/applicant'),
    controllerAs: 'vm',
    data:{
      authenticate: true,
      title: 'Good Exchange - Invitation To Join Applicant',
    }
});

setup.state('portal.funder-invite',{
    url: '/funder-invite?id',
    template: require('./invite/index.pug')(),
    controller: require('./invite/funder'),
    controllerAs: 'vm',
    data:{
      authenticate: true,
      title: 'Good Exchange - Invitation To Join Funder',
    }
});



// require in any modules
require('./login');
require('./signup');
require('./verify-email');
require('./password');
require('./reset-password');

setup.auth(require('./auth'));


// init app module
var app = setup.done();

SetupAnalytics(app);
